import { BaseService } from '@morningstar/shared/base/base-service';

export abstract class BaseComponent {

  processing$ = this.service.processing$;
  errorMessage$ = this.service.errorMessage$;

  constructor(protected service: BaseService) { }
}
